module.exports = "/assets/dist/images/Apple.png?2b4081df119c4c048ce7863ac5e29026";